import moment from 'moment';
import { Page } from '../model/elements';
import { TaskPermissionActionFolder } from '../model/entities';
import { syncApiAxios } from './CustomAxios';

class TaskPermissionActionFolderApi {
    list = async (
        page: number,
        size: number,
        sortField: string,
        sortOrder: boolean,
        taskPermissionLinkId: number,
        searchText?: string,
        parentId?: number,
    ): Promise<Page<TaskPermissionActionFolder>> => {
        const response = await syncApiAxios.get<Page<TaskPermissionActionFolder>>('/task-permission-action-folders', {
            params: { page, size, sortField, sortOrder, taskPermissionLinkId, searchText, parentId },
        });
        response.data.sort.field = sortField;
        response.data.sort.order = sortOrder;
        response.data.content.forEach((d) => {
            d.audit!.created = d.audit!.created && moment.utc(d.audit!.created).local();
            d.audit!.updated = d.audit!.updated && moment.utc(d.audit!.updated).local();
        });

        return response.data;
    };

    get = async (id: number): Promise<TaskPermissionActionFolder> => {
        const response = await syncApiAxios.get<TaskPermissionActionFolder>(`/task-permission-action-folders/${id}`);
        response.data.audit!.created = response.data.audit!.created && moment.utc(response.data.audit!.created).local();
        response.data.audit!.updated = response.data.audit!.updated && moment.utc(response.data.audit!.updated).local();

        return response.data;
    };
}

const taskPermissionActionFolderApi: TaskPermissionActionFolderApi = new TaskPermissionActionFolderApi();
export default taskPermissionActionFolderApi;
